import React, { useState } from "react";

import bagshQR from "../../../assets/img/QR2023/iform_bagsh.jpeg";
import menejQR from "../../../assets/img/QR2023/iform_menej.jpeg";

import ppt1 from "../../../assets/2024_PDF/СХОГ_ын_дарга.pptx";
import ppt1_intro from "../../../assets/2024_PDF_Intro/ppt1_intro.png";

import ppt2 from "../../../assets/2024_PDF/2_ЗГ_ын_тогтоол,_журмын_танилцуулга.pptx";
import ppt2_intro from "../../../assets/2024_PDF_Intro/ppt2_intro.png";

import ppt3 from "../../../assets/2024_PDF/4_Багшийн_мэргэжил_дээшлүүлэх_зардал.pptx";
import ppt3_intro from "../../../assets/2024_PDF_Intro/ppt3_intro.png";

import ppt4 from "../../../assets/2024_PDF/Аргачлал_2024.pptx";
import ppt4_intro from "../../../assets/2024_PDF_Intro/ppt4_intro.png";

import ppt5 from "../../../assets/2024_PDF/Заавар_Хичээл,_сургалтын_үйл_ажиллагаа_2024.pptx";
import ppt5_intro from "../../../assets/2024_PDF_Intro/ppt5_intro.png";

import ppt6 from "../../../assets/2024_PDF/PPT_2024_02_28.pptx";
import ppt6_intro from "../../../assets/2024_PDF_Intro/ppt6_intro.png";

import ppt7 from "../../../assets/2024_PDF/Цахим_хэрэглээний_зардал.pptx";
import ppt7_intro from "../../../assets/2024_PDF_Intro/ppt7_intro.png";
import legal1 from "../../../assets/2024_PDF/39.pdf";
import legal2 from "../../../assets/2024_PDF/Байгууллагын_гүйцэтгэлийн_үнэлгээ.pdf";
import legal3 from "../../../assets/2024_PDF/Мэргэжлийн боловсрол_466.pdf";
import pdf2026 from "../../../assets/2026_img/material.pdf";
import thumb_pdf2026 from "../../../assets/2026_img/materialthum.png";

const materials = [
  {
    introImg: thumb_pdf2026,
    src: pdf2026,
  },
  // {
  //   introImg: ppt2_intro,
  //   src: ppt2,
  // },
  // {
  //   introImg: ppt3_intro,
  //   src: ppt3,
  // },
  // {
  //   introImg: ppt4_intro,
  //   src: ppt4,
  // },
  // {
  //   introImg: ppt5_intro,
  //   src: ppt5,
  // },
  // {
  //   introImg: ppt6_intro,
  //   src: ppt6,
  // },
  // {
  //   introImg: ppt7_intro,
  //   src: ppt7,
  // },
];
const pdfLegal = [
  {
    id: "1",
    name: "Монгол улсын Засгийн газрын 2024 оны 01 дүгээр сарын 25-ны өдрийн 39 дүгээр тогтоол",
    source: legal1,
  },
  {
    id: "2",
    name: "Монгол улсын Засгийн газрын 2024 оны 01 дүгээр сарын 17-ны өдрийн 25 дугаар тогтоол",
    source: legal2,
  },
  {
    id: "3",
    name: "Монгол улсын Засгийн газрын 2023 оны 12 дугаар сарын 27-ны өдрийн 466 дугаар тогтоол",
    source: legal3,
  },
];

export default function PDFsection() {
  const [scheduleKey, setScheduleKey] = useState("day-1");

  const eventDays = [
    // {
    //   id: "day-1",
    //   label: "Нэгдсэн уулзалт",
    // },
    // {
    //   id: "day-2",
    //   label: "Салбар уулзалт",
    // },
    {
      id: "day-1",
      label: "8-р сарын уулзалтын материал",
    },
    // {
    //   id: "day-2",
    //   label: "Эрх зүйн баримт бичиг",
    // },
    // {
    //   id: "day-3",
    //   label: "Санал  асуулга",
    // },
  ];

  // console.log("DATE: ", activeDate);

  return (
    // balai neg material oruulah gej hatuu undur zaalaa 400 geed
    <div className="container mt-5" style={{ height: 400 }}>
      <div class="section-title" data-aos="fade-up">
        <h2>Хөтөлбөр</h2>
        <p>Төсвийн шинэчлэл 2026 уулзалт</p>
      </div>
      <div className="schedule">
        {/* <h3 class="sub-heading">
          БОЛОВСРОЛЫН САЛБАРЫН САНХҮҮЖИЛТИЙН ШИНЭЧЛЭЛ СЭДЭВТ СУРГАЛТЫН ХӨТӨЛБӨР
        </h3> */}

        <ul
          class="nav nav-tabs "
          role="tablist"
          data-aos="fade-up"
          data-aos-delay="100"

          // className="w-100 d-flex justify-content-center mt-3"
        >
          {eventDays.map((el, i) => (
            <li
              class="nav-item row gy-3 align-middle"
              onClick={() => setScheduleKey(`day-${i + 1}`)}
            >
              <a
                class={`nav-link ${el.id === scheduleKey ? "active" : ""}`}
                role="tab"
                data-bs-toggle="tab"
              >
                {el.label}
              </a>
            </li>
          ))}
        </ul>

        <div
          class="tab-content row justify-content-center"
          data-aos="fade-up"
          data-aos-delay="200"
        >
          {scheduleKey === "day-1" && (
            <div
              role="tabpanel"
              class="question-tab col-lg-9 tab-pane fade show active min-h-0 h-auto"
            >
              <div className="mt-4 row gy-4">
                {/* <a target="_blank" href={pdfBook}>
                  <img src={bookIntro} width={180}></img>
                </a> */}
                {materials.map((el, i) => (
                  <div className="col-sm-3" key={i}>
                    <a target="_blank" href={el.src} rel="noreferrer">
                      <img src={el.introImg} className="w-100"></img>
                    </a>
                  </div>
                ))}
              </div>
            </div>
          )}

          {scheduleKey === "day-2" && (
            <div
              role="tabpanel"
              class="question-tab  tab-pane fade show active"
            >
              <div className="d-flex flex-column">
                {/* <a target="_blank" href={pdfBook}>
                  <img src={bookIntro} width={180}></img>
                </a> */}
                {pdfLegal.map((el, i) => (
                  <div
                    className="col-sm-2 w-100 p-2"
                    class="border rounded my-3 p-2"
                    key={i}
                  >
                    <h5 class="text-primary font-weight-bold">
                      {el.id}. {el.name}
                    </h5>
                    <div class="d-flex flex-row-reverse ">
                      <a
                        target="_blank"
                        rel="noreferrer"
                        class="border rounded px-2 "
                        href={el.source}
                      >
                        Дэлгэрэнгүй
                      </a>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
          {scheduleKey === "day-3" && (
            <div
              role="tabpanel"
              class="question-tab row gy-2 tab-pane fade show active"
            >
              <div class="d-flex flex-row justify-content-around mt-3">
                <div className="d-flex flex-column w-25 mx-2 text-center">
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href={
                      "https://iform.esis.edu.mn/form/63719ae9f90a4528a713d4ef"
                    }
                  >
                    <div style={{ height: "80px" }}>
                      <h5>Захирал, менежерийн хариулах асуумж</h5>
                    </div>
                  </a>
                  <img src={menejQR} alt="" />
                </div>
                <div className="d-flex flex-column w-25 mx-2 text-center">
                  <div>
                    <a
                      target="_blank"
                      rel="noreferrer"
                      href={
                        "https://iform.esis.edu.mn/form/63719b7cf90a4528a713d4f0"
                      }
                    >
                      <div style={{ height: "80px" }}>
                        <h5>Багшийн хариулах асуумж</h5>
                      </div>
                    </a>
                  </div>
                  <img src={bagshQR} alt="" />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
